import React from 'react';
import PropTypes from 'prop-types';
import { FormRow, Select } from '@here/ref-client-ui';
import './inputSearch.scss';
import { FORM_TYPES } from '../../state/tabs/tab/selectedForm/constants';

function RulesFormDropdown({ onRuleFormChange, selectedFormType = FORM_TYPES.GLOBAL,formTypeOptions = [] }) {
  
  return (
    <FormRow className="rf-input-rules-form-dropdown" label="Rules Type">
      <Select
        label="Rules Type"
        options={formTypeOptions}
        value={selectedFormType}
        onChange={onRuleFormChange}
        addEmptyOption={false}
      />
    </FormRow>
  );
}

RulesFormDropdown.propTypes = {
  onRuleFormChange: PropTypes.func.isRequired,
  selectedFormType: PropTypes.string,
};

export default RulesFormDropdown;